import { LabelValueStickerWrapper } from '@tableau/catalog-ui-temp';
import { BodyCell } from '@tableau/widgets-datagrid';
import React from 'react';

import { StyledCellFormatter } from '~src/spacesPlatform/components/ListView/StyledCellWrapper';

export function LabelValueCell(labelCategoryPropName: string, labelValuePropName: string, isSeverePropName: string, testId?: string, styleOverride?: React.CSSProperties): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(
        function LabelValueCell(props: BodyCell.Props) {
          return <LabelValueStickerWrapper
                  category={props.row.data[labelCategoryPropName]}
                  value={props.row.data[labelValuePropName]}
                  isSevere={props.row.data[isSeverePropName]}
                />;
        },
        styleOverride
    );
  }